import Api from '../../shared/Api';

class AgreementProductsApi {
    static list(): any {
        return new Api().get('/views/photographers/me/agreement');
    }
}

export default AgreementProductsApi;
